// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3W776","title":"ClientReferral_title__2mDrW","itemText":"ClientReferral_itemText__1s7VI"};